/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope.
 * - openCart: open Artink header cart dropdown (never redirect to /cart).
 */

function openArtinkCart() {
  if (window.ArtinkCart?.openDropdown?.()) return true;
  const toggle = document.querySelector('[data-artink-header] [data-cart-toggle]');
  const drop = document.querySelector('[data-artink-header] [data-cart-dropdown]');
  if (toggle && drop) {
    if (drop.hidden) toggle.click();
    return true;
  }
  return false;
}

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
  });

  actions.openCart.configure({
    async handler() {
      if (openArtinkCart()) return;

      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (drawer?.open) {
        drawer.open();
        return;
      }
      // Stay on the current page — cart badge is updated separately via ArtinkCart.refresh
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
